import { lazy } from 'react'

export const CodeComp = lazy(() => import('./CodeLazy'))
